const countryCodes: Record<string, string> = {
  argentina: "ar", australia: "au", austria: "at", belgium: "be", brazil: "br", bulgaria: "bg", canada: "ca", chile: "cl", china: "cn", colombia: "co", croatia: "hr",
  czechia: "cz", "czech republic": "cz", denmark: "dk", estonia: "ee", finland: "fi", france: "fr", germany: "de", greece: "gr", hungary: "hu", india: "in",
  indonesia: "id", ireland: "ie", israel: "il", italy: "it", japan: "jp", kazakhstan: "kz", latvia: "lv", lithuania: "lt", malaysia: "my", mexico: "mx", netherlands: "nl",
  "new zealand": "nz", norway: "no", peru: "pe", philippines: "ph", poland: "pl", portugal: "pt", romania: "ro", russia: "ru", serbia: "rs", singapore: "sg",
  slovakia: "sk", slovenia: "si", "south africa": "za", "south korea": "kr", spain: "es", sweden: "se", switzerland: "ch", taiwan: "tw", thailand: "th", turkey: "tr",
  ukraine: "ua", "united arab emirates": "ae", "united kingdom": "gb", "united states": "us", uruguay: "uy", vietnam: "vn",
};

function normalizeCountry(country: string) {
  const value = country.trim().toLowerCase();
  return countryCodes[value] ?? value.slice(0, 2);
}

export function CountryMark({ country }: { country: string }) {
  if (!country) return null;
  const code = normalizeCountry(country);
  if (code === "ru" || country.trim().toLowerCase() === "russia") {
    return <span className="country-mark" aria-label="Russia">💩</span>;
  }
  return <img className="country-flag" src={`/media/flag/${code}`} alt={country} title={country} />;
}
